// extracted by mini-css-extract-plugin
export default {"completed":"AuscultationList_completed__sGGXe","expired":"AuscultationList_expired__NrZDl"};